module.exports = __webpack_public_path__ + "img/armory_tech_Normal_ua.aab174bc.webp";